import cartReducer from "./cartReducer";

export const cartReducers = {
  cart: cartReducer,
};
